<!-- eslint-disable vue/no-v-html -->
<script setup lang="ts">
import { vInterpolate } from '@/directives/v-interpolate'
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementText']
}>()

const runtimeConfig = useRuntimeConfig()
const route = useRoute()
const { availableLocales } = useI18n()

const localizedContent = computed(() => {
    const html = props.content.data?.content
    if (!html) return html

    const baseURL = runtimeConfig.app.baseURL as string
    const basePrefix = baseURL && baseURL !== '/' ? baseURL.replace(/\/$/, '') : ''

    const routeFirstSegment = route.path.replace(/^\//, '').split('/')[0]
    const locale = routeFirstSegment && (availableLocales as string[]).includes(routeFirstSegment)
        ? routeFirstSegment
        : ''

    const prefix = basePrefix + (locale ? `/${locale}` : '')
    if (!prefix) return html

    return html.replace(/href="(\/[^"]*)"/g, (_, path: string) => {
        if (path.startsWith(`${prefix}/`) || path === prefix) return `href="${path}"`
        return `href="${prefix}${path}"`
    })
})
</script>

<template>
    <div
        :id="content.config?.id?.value"
        class="h-full flex flex-col m-auto"
        :class="{
            'navigationSection': content.config?.id?.value,
            'headlineElement': content.config?.headlineElement?.value,
            'p-4': !content.config?.disablePaddings?.value
        }"
    >
        <div
            v-if="content.data?.content != null"
            v-interpolate
            class="prose max-w-full"
            :class="{
                'm-auto': content?.config?.verticalAlign?.value === 'center',
                'mb-auto': content?.config?.verticalAlign?.value === 'flex-start',
                'mt-auto': content?.config?.verticalAlign?.value === 'flex-end',
            }"
            v-html="localizedContent"
        />
    </div>
</template>
